import { Circle } from "./Circle";
import { fade, grow, moveTo } from "./animations";

export class TrailParticle extends Circle {
  constructor({
    x,
    y,
    color,
    radius,
    duration = 0.5,
    moveABit = false,
  }: {
    x: number;
    y: number;
    color: number;
    radius: number;
    duration?: number;
    moveABit?: boolean;
  }) {
    super({ x, y, color, radius });
    this.alpha = 0.6;
    this.blendMode = "add";

    const xJitter = (Math.random() - 0.5) * 2; // add some random horizontal jitter
    const yJitter = (Math.random() - 0.5) * 2; // add some random vertical jitter

    this.x += xJitter;
    this.y += yJitter;

    const moveDistance = 30; // how far the particle should move
    const moveAngle = Math.random() * Math.PI * 2; // random direction to move in

    const targetX = this.x + Math.cos(moveAngle) * moveDistance;
    const targetY = this.y + Math.sin(moveAngle) * moveDistance;

    const jitteredDuration = duration + Math.random() * 0.5; // add some random variation to the duration

    const animations = [
      fade(this, jitteredDuration, 0),
      grow(this, 0, jitteredDuration),
    ];

    if (moveABit) {
      animations.push(
        moveTo(this, jitteredDuration, { x: targetX, y: targetY }),
      );
    }

    Promise.all(animations).then(() => {
      this.destroy();
    });
  }
}

export default TrailParticle;
